module.exports = __webpack_public_path__ + "e88f127c2272d2cf17d6f070d4fb42b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/monster_energy_company_2023_chart.png
// module id = 1700
// module chunks = 0